import { useParams, Link, Navigate } from "react-router-dom";
import { POLICIES, POLICY_META } from "@/data/policies";
import { ArrowLeft, FileText } from "lucide-react";

function renderBody(body) {
  // Split by blank lines into paragraphs; lines beginning with "- " become bullets.
  const blocks = body.split(/\n\n+/);
  return blocks.map((block, bi) => {
    const lines = block.split(/\n/);
    if (lines.every((l) => l.trim().startsWith("- "))) {
      return (
        <ul key={bi} className="mt-2 list-disc space-y-1 pl-5 text-sm text-slate-800">
          {lines.map((l, i) => (
            <li key={i}>{l.replace(/^- /, "")}</li>
          ))}
        </ul>
      );
    }
    return (
      <p key={bi} className="mt-2 text-sm leading-relaxed text-slate-800">
        {block}
      </p>
    );
  });
}

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = POLICIES[slug];
  if (!policy) return <Navigate to="/" replace />;

  return (
    <main data-testid={`policy-page-${slug}`} className="mx-auto max-w-3xl px-6 py-16">
      <Link
        to="/"
        className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-[0.2em] text-blue-700 hover:underline"
      >
        <ArrowLeft className="h-3 w-3" /> Back to home
      </Link>
      <div className="mt-6 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-blue-700">
        <FileText className="h-3 w-3" />
        {POLICY_META.PRODUCT}
      </div>
      <h1 className="mt-3 font-heading text-4xl font-semibold tracking-tight sm:text-5xl">
        {policy.title}
      </h1>
      <div className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
        Effective {POLICY_META.EFFECTIVE} · {POLICY_META.COMPANY}
      </div>
      <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-800">
        {policy.intro}
      </p>

      <div className="mt-12 space-y-10">
        {policy.sections.map((s, i) => (
          <section key={i} data-testid={`policy-section-${i}`}>
            <h2 className="font-heading text-lg font-semibold text-slate-900">
              {s.heading}
            </h2>
            {renderBody(s.body)}
          </section>
        ))}
      </div>

      <div className="mt-16 border-t border-slate-200 pt-6 text-xs text-slate-500">
        © 2026 {POLICY_META.PRODUCT} | {POLICY_META.COMPANY} —{" "}
        <Link to="/cookies" className="hover:underline">Cookies</Link>{" "}·{" "}
        <Link to="/privacy" className="hover:underline">Privacy</Link>{" "}·{" "}
        <Link to="/terms" className="hover:underline">Terms</Link>{" "}·{" "}
        <Link to="/disclaimer" className="hover:underline">Disclaimer</Link>
      </div>
    </main>
  );
}
